import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import games from "../data/gamesData";
import { getStoreUrlForDevice } from "../utils/storeRedirect";
import { logEvent } from "../firebase";

export default function StoreGo() {
  const { id } = useParams();
  const game = games.find((g) => g.id === id);

  useEffect(() => {
    if (!game) return;

    const robots = document.querySelector('meta[name="robots"]');
    const tag = robots || document.createElement("meta");
    tag.setAttribute("name", "robots");
    tag.setAttribute("content", "noindex, nofollow");
    if (!robots) document.head.appendChild(tag);

    const storeUrl =
      getStoreUrlForDevice(game.appStoreUrl, game.playStoreUrl) ||
      game.appStoreUrl ||
      game.playStoreUrl;
    if (!storeUrl) return;

    logEvent("app_page_store_redirect", {
      app: game.shortTitle || game.title,
      via: "go",
    });
    window.location.replace(storeUrl);
  }, [game]);

  if (!game) {
    return (
      <h2 style={{ paddingTop: 100, textAlign: "center" }}>App not found</h2>
    );
  }

  const fallback = game.appStoreUrl || game.playStoreUrl;
  return (
    <div style={{ padding: "120px 24px", textAlign: "center" }}>
      <p>Opening the store…</p>
      {fallback ? (
        <p>
          <a href={fallback}>Continue to download</a>
        </p>
      ) : (
        <p>
          <Link to={`/apps/${game.id}`}>View the {game.shortTitle} app page</Link>
        </p>
      )}
    </div>
  );
}
